import { render, staticRenderFns } from "./RanchCredit.vue?vue&type=template&id=4d147e78&"
import script from "./RanchCredit.vue?vue&type=script&lang=js&"
export * from "./RanchCredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports